import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { MultipleActionsParams } from "go-list/list/services/types";
import { api } from "../../../../../../../../../../services/Api/api";

interface Props {
	show: boolean;
	onHide: () => void;
	productIds: number[];
	handleSave: () => void;
	allItemsSelected: boolean;
	multipleActionParams?: MultipleActionsParams;
}

interface FormProps {
	tax_id: number | null;
}

const ChangeProductsTaxModal = ({
	onHide,
	show,
	productIds,
	handleSave,
	allItemsSelected,
	multipleActionParams,
}: Props): JSX.Element => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const { addFlash, addSuccessFlash } = useFlash();
	const form = useForm<FormProps>({
		criteriaMode: "all",
	});
	const { handleSubmit, formState, control, setError } = form;

	const onSubmit = handleSubmit(async (data: FormProps) => {
		if (data.tax_id === undefined) data.tax_id = null;
		setLoading(true);
		try {
			const params: Record<string, any> = multipleActionParams ? { ...multipleActionParams } : {};
			if (!allItemsSelected) params.id = productIds.join(",");
			await api.organization().patchItemGroups(data, params);
			addSuccessFlash(t("lib:common.flash.saved"));
			onHide();
			handleSave();
		} catch (err) {
			handleError.form(err, setError, addFlash);
		}
		setLoading(false);
	});

	const searchTaxes = (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		return api.organization().getTaxesSearchSelect(search, params, {
			cancelToken: options?.token,
		});
	};

	return (
		<Modal show={show} onHide={onHide}>
			<FormDirty formState={formState}>
				<Modal.Header closeButton>
					<Modal.Title>{t("modules.item_group.action.set_tax.title")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FormSelectGroup
						errors={[]}
						label={t("common.word.tax")}
						control={control}
						name="tax_id"
						loadOptions={searchTaxes}
						getOptionValue={(option) => option.id}
						data-testid="tax_id"
					/>
				</Modal.Body>
				<Modal.Footer>
					<ButtonLoading loading={loading} type="submit" onClick={onSubmit}>
						{t("lib:common.action.save")}
					</ButtonLoading>
					<Button variant="light" onClick={onHide}>
						{t("lib:common.action.cancel")}
					</Button>
				</Modal.Footer>
			</FormDirty>
		</Modal>
	);
};

export default ChangeProductsTaxModal;
